import React, { useEffect } from "react";
import { StudentInvalidCode } from "components/StudentOnboarding";
import StudentLogin from "./StudentLogin";
import { AnalyticsProvider } from "utils/analytics/AnalyticsContext";
import { SurfaceType } from "utils/analytics/analyticsConstants";
import { useNavigate, useLocation } from "react-router-dom";

export default function StudentInviteLogin() {
  const location = useLocation();
  const navigate = useNavigate();

  const fromConnectCodePage =
    location?.state && location.state.from === "/connect";

  useEffect(() => {
    if (!fromConnectCodePage) {
      return navigate("/connect", { replace: true });
    }
  }, [fromConnectCodePage, navigate]);

  const event = location.state?.event;

  if (
    !event ||
    event.type !== "CONNECT_CODE_STATE" ||
    !event.schoolName ||
    !event.connectCode
  ) {
    return (
      <AnalyticsProvider surface={SurfaceType.STUDENT_INTRODUCTION_PAGE}>
        <StudentInvalidCode />
      </AnalyticsProvider>
    );
  }

  return (
    <StudentLogin
      schoolName={event.schoolName}
      connectCode={event.connectCode}
    />
  );
}
